import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import VueAnalytics from "vue-analytics";

// Require dependencies
var VueCookie = require("vue-cookie");
// Tell Vue to use the plugin
Vue.use(VueCookie);

Vue.config.productionTip = false;

Vue.use(VueAnalytics, {
  // 本番
  id: "UA-122954775-3",
  router,
});

new Vue({
  router,
  render: (h) => h(App),
}).$mount("#app");
